import { Text } from "react-native-paper";
import { useTailwind } from "tailwind-rn";

import { Inventory } from "../types";

type Props = {
  inventory: Inventory;
};
export default function InventoryText({ inventory }: Props) {
  const tailwind = useTailwind();

  const { enabled, quantity } = inventory;

  const text = enabled ? `Disponible: ${quantity}` : "Sin inventario activo";

  return (
    <Text variant="bodyMedium" style={tailwind("mt-1")}>
      {text}
    </Text>
  );
}
